import cx from 'classnames'

import { StyledTableData, StyledTableRow } from '../styles'
import type { TableProps } from '../types'

type TableBodyProps = Required<Pick<TableProps, 'rows' | 'fontWeight'>>

export const TableBody = ({ rows, ...commonProps }: TableBodyProps) => {
  if (!rows.length) return null
  return (
    <tbody role="rowgroup">
      {rows.map((row, rowIndex) => {
        const isLastRow = rowIndex === rows.length - 1
        return (
          <StyledTableRow
            role="row"
            key={rowIndex}
            {...commonProps}
            className={cx({ 'table__last-row': isLastRow })}
          >
            {row.cells.map((cell, cellIndex) => (
              <StyledTableData role="cell" key={cellIndex} {...commonProps}>
                {cell.text}
              </StyledTableData>
            ))}
          </StyledTableRow>
        )
      })}
    </tbody>
  )
}
